import pickBy from 'lodash/pickBy';
import { IThumbnailReducerStateProps } from '.';

const regex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}/;

export const flushWithTimestamp = (
  state: IThumbnailReducerStateProps,
): IThumbnailReducerStateProps =>
  pickBy(state, (_, key) => !regex.test(key));
